export default __webpack_public_path__ + "static/media/discord.0bb2669f.svg";